import React from 'react'
import { InputBase, InputAdornment } from '@mui/material'
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker'
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { parseISO } from 'date-fns'

const isValidDateString = (dateString) => {
  if (
    !/^([1-9]|(0)[1-9]|[1-2]\d|(3)[0-1])(\/|\-)(([1-9]|(0)[1-9])|((1)[0-2]))(\/|\-)\d{4}$/.test(
      dateString
    )
  )
    return false
  return true
}

export default function DateRangePicker(_props) {
  const {
    label = '', // texto del label
    name = '', // nombre del campo para manejo de datos
    type = 'text', // tipo de campo
    defaultValue = '', // valor por defecto
    helperText = '', // texto de ayuda
    validation = {}, // validaciónes
    autoFocus = false, // autofocus
    options = null, // opciones para el select
    placeholder = '', // placeholder para el input
    fromDate = null,
    toDate = new Date(),
    handleFromChange = () => {
      console.warn('provide handleFromChange')
    },
    handleToChange = () => {
      console.warn('provide handleToChange')
    },
    errors,
    ...inputProps
  } = _props

  const [isFromDateOpen, setIsFromDateOpen] = React.useState(false)
  const [isToDateOpen, setIsToDateOpen] = React.useState(false)

  let maxDate = new Date(toDate)
  let minDate = fromDate ? new Date(fromDate) : new Date(0)

  return (
    <div className="flex flex-row items-center gap-4">
      <div>Desde:</div>
      <DatePicker
        value={fromDate}
        onChange={handleFromChange}
        {...inputProps}
        name="fromdate"
        disableFuture={true}
        fullWidth={true}
        inputFormat="dd-MM-yyyy"
        maxDate={maxDate}
        toolbar={false}
        open={isFromDateOpen}
        onClose={() => setIsFromDateOpen(false)}
        inputProps={{
          readOnly: true,
        }}
        orientation="portrait"
        renderInput={({ inputRef, inputProps, InputProps }) => (
          <InputBase
            ref={inputRef}
            fullWidth={true}
            {...inputProps}
            onClick={() => setIsFromDateOpen(true)}
            endAdornment={
              <InputAdornment position="end">
                {InputProps?.endAdornment}
              </InputAdornment>
            }
          />
        )}
      />
      <div>hasta:</div>
      <DatePicker
        value={toDate}
        onChange={handleToChange}
        name="todate"
        {...inputProps}
        disableFuture={true}
        fullWidth={true}
        inputFormat="dd-MM-yyyy"
        minDate={minDate}
        open={isToDateOpen}
        onClose={() => setIsToDateOpen(false)}
        inputProps={{
          readOnly: true,
        }}
        orientation="portrait"
        renderInput={({ inputRef, inputProps, InputProps }) => (
          <InputBase
            ref={inputRef}
            fullWidth={true}
            {...inputProps}
            onClick={() => setIsToDateOpen(true)}
            endAdornment={
              <InputAdornment position="end">
                {InputProps?.endAdornment}
              </InputAdornment>
            }
          />
        )}
      />
    </div>
  )
}
